import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';

const RightTit = ({ txt }) => (
    <div className={styles.tit}>
        <p className={styles.txt}>{txt}</p>
    </div>
);

RightTit.propTypes = {
    txt: PropTypes.string,
};

export default RightTit;
